import { SearchTerm } from "./SearchTerm";

const HolidaySearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "holName",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
];

export default HolidaySearch;
